import { observable, action } from 'mobx'
import moment from 'moment'
import { hashHistory } from 'react-router'
import { JIAMENG_SCHEDULE } from '@constant'
import Api from '@api/jiaMeng'

class Store {
  @observable currentDate = moment()
  @observable calendarTasks = {}
  @observable loading = false

  @action
  onSelect = value => {
    const date = moment(value).format(__FMT1__)
    hashHistory.push(`${JIAMENG_SCHEDULE}?date=${date}`)
  }

  @action
  nextMonth = () => {
    this.currentDate = moment(this.currentDate).add(1, 'months')
    this.getCalendarTask()
  }

  @action
  prevMonth = () => {
    this.currentDate = moment(this.currentDate).subtract(1, 'months')
    this.getCalendarTask()
  }

  getCalendarTask = async () => {
    this.loading = true
    const { success, data } = await Api.getCalendarTask({
      date: this.currentDate.format(__FMT1__),
      show: 0,
      type: 2 // 月
    })

    this.loading = false
    if (success) {
      this.calendarTasks = data
    }
  }
}

export default Store
